import { UserImage } from "@circle-react-uikit/UserImage";
import type { ImageInputRenderProps } from "@/react/components/shared/ImageUploadInput/ImageInputRender";
import { Button } from "@/react/components/shared/uikit/Button";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface RenderImagePreviewProps extends ImageInputRenderProps {
  testimonialName: string;
}

export const RenderImagePreview = ({
  value,
  processing: isProcessing,
  imageUrl,
  handleChangeCoverClick,
  handleDelete,
  testimonialName,
}: RenderImagePreviewProps) => {
  const isNewState = !value && !isProcessing;
  const defaultClassName = "w-5 h-5";

  if (isNewState) {
    return (
      <Button
        className={classNames(defaultClassName, "!p-0")}
        type="button"
        variant="circle-plain"
        onClick={handleChangeCoverClick}
        data-testid="cover-image-add"
      >
        <UserImage name={testimonialName} isFullRounded size="6" />
      </Button>
    );
  }

  if (isProcessing) {
    return (
      <div
        className={classNames(defaultClassName, "bg-secondary rounded-full")}
      />
    );
  }

  return (
    <Button
      type="button"
      variant="circle-plain"
      onClick={handleDelete}
      className={classNames(
        "hover:text-dark !hover:bg-primary !p-0",
        defaultClassName,
      )}
      data-testid="cover-image-delete"
    >
      <UserImage name={testimonialName} isFullRounded size="6" src={imageUrl} />
    </Button>
  );
};
